import { HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { AbsenceLeave } from '../entities/absence-leave';
import { CostCenter } from '../entities/costCenter';
import { Hhelpdesk } from '../entities/hhelpdesk';
import { tap, catchError, switchAll } from 'rxjs/operators';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Observable } from 'rxjs/Observable';
import { Employee } from '../entities/employee';
import { EmployeeManager } from '../entities/employee-manager';
import { AbsenceLeaveImport } from '../model/absence-leave-import';

interface ExtraSearchFields {
  month?: Hhelpdesk,
  costCenter?: CostCenter,
  employee?: Employee,
  employeeManager? : EmployeeManager,
  employeeId?: number
}


@Injectable()
export class AbsenceLeaveService extends BaseCrudService<AbsenceLeave> {

  uri = '/api/absenceLeave/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance AbsenceLeaveService');
  }

  buildSentence(entity?: AbsenceLeave, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        entity && entity.sequence ?
          `sequence${QueryOperator.Contain}${entity.sequence}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.checkOutTime ?
          `checkOutTime${QueryOperator.Equal}${entity.checkOutTime}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.checkInTime ?
          `checkInTime${QueryOperator.Equal}${entity.checkInTime}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.difference ?
          `difference${QueryOperator.Contain}${entity.difference}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.isMassive ?
          `isMassive${QueryOperator.Equal}${entity.isMassive}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity &&  entity.isAttachment ?
          `isAttachment${QueryOperator.Equal}${entity.isAttachment}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.status ?
          `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.isApprovedhr ?
          `isApprovedhr${QueryOperator.Equal}${entity.isApprovedhr}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.processingPeriod ?
          `processingPeriod${QueryOperator.Contain}${entity.processingPeriod}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.creationDate ?
          `creationDate${QueryOperator.Equal}${entity.creationDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.isRescheduled ?
          `isRescheduled${QueryOperator.Equal}${entity.isRescheduled}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.checkOutRescheduled ?
          `checkOutRescheduled${QueryOperator.Equal}${entity.checkOutRescheduled}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.checkInRescheduled ?
          `checkInRescheduled${QueryOperator.Equal}${entity.checkInRescheduled}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.formatNumber ?
          `formatNumber${QueryOperator.Contain}${entity.formatNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.documentNumber ?
          `documentNumber${QueryOperator.Contain}${entity.documentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.comment ?
          `comment${QueryOperator.Contain}${entity.comment}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity && entity.approvalComment ?
          `approvalComment${QueryOperator.Contain}${entity.approvalComment}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity && entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      if (entity && entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
        );
      }
      if (entity && entity.absence && entity.absence.id) {
        query = query.concat(
          `absence.id${QueryOperator.Equal}${entity.absence.id}${QueryOperator.Split}`
        );
      }
      if (entity && entity.state && entity.state.id) {
        query = query.concat(
          `state.id${QueryOperator.Equal}${entity.state.id}${QueryOperator.Split}`
        );
      }
      if (entity && entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      if (entity && entity.approverLevel1 && entity.approverLevel1.id) {
        query = query.concat(
          `approverLevel1.id${QueryOperator.Equal}${entity.approverLevel1.id}${QueryOperator.Split}`
        );
      }
      if (entity && entity.approverLevel2 && entity.approverLevel2.id) {
        query = query.concat(
          `approverLevel2.id${QueryOperator.Equal}${entity.approverLevel2.id}${QueryOperator.Split}`
        );
      }

      query = query.concat(
        extraSearchFields && extraSearchFields.employeeId ?
          `approverLevel1.employee.id${QueryOperator.Equal}${extraSearchFields.employeeId}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.month ?
          `checkOutTime${QueryOperator.EqualMonth}${extraSearchFields.month.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.costCenter ?
          `costCenter.id${QueryOperator.Equal}${extraSearchFields.costCenter.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.employee ?
          `employee.id${QueryOperator.Equal}${extraSearchFields.employee.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.employeeManager ?
          `approverLevel1.id${QueryOperator.Equal}${extraSearchFields.employeeManager.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

 
  approveListAbsencesByRRHH(absencesLeaveList?: Number[]): Observable<ResponsePageable<AbsenceLeave>> { 
  const url = `${this.rutaServidor}${this.uri}approveListAbsencesByRRHH`;
  //let httpParams = this.buildSentence(entity, event, extraSearchFields);
  //httpParams = this.httpParams.set(QueryOperator.SearchName, 'searchToRRHH');
  this.spinnerService.showAll();
  return this.httpClient.post<ResponsePageable<AbsenceLeave>>(url,absencesLeaveList ) 
     .pipe(
          tap(response => { 
          if (response.numberOfElements > 0) {
                //console.log(response);
                response.content.forEach((value) => {
                // debugger;
                this.addLogicToSearch(value);
                // this.convertToDate(value);
                })
            }
            //console.log(response);
            this.spinnerService.hideAll();
          return response;
          })
    ); 
  }

  approveListAbsencesByEmployeeManager(absencesLeaveList?: Number[], employeeManagerId? : number): Observable<String> { 
    const url = `${this.rutaServidor}${this.uri}approveListAbsencesByEmployeeManager/${employeeManagerId}`;
     //let httpParams = this.buildSentence(entity, event, extraSearchFields);
    //httpParams = this.httpParams.set(QueryOperator.SearchName, 'searchToRRHH');
    this.spinnerService.showAll();
    return this.httpClient.post<String>(url,absencesLeaveList) 
       .pipe(
            tap(response => { 
           /* if (response.numberOfElements > 0) {
                  //console.log(response);
                  response.content.forEach((value) => {
                  // debugger;
                  //this.addLogicToSearch(value);
                  // this.convertToDate(value);
                  })
              }*/
              //console.log(response);
              this.spinnerService.hideAll();
            return response;
            })
      ); 
    }


  searchToRRHH(entity?: AbsenceLeave, event?: LazyLoadEvent,
        extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<AbsenceLeave>> { 
      const url = `${this.rutaServidor}${this.uri}search`;
      let httpParams = this.buildSentence(entity, event, extraSearchFields);
      httpParams = this.httpParams.set(QueryOperator.SearchName, 'searchToRRHH');
      this.spinnerService.showAll();
      return this.httpClient.get<ResponsePageable<AbsenceLeave>>(url, { params: httpParams })
        .pipe(
              tap(response => {
              //console.log('searchToRRHH');
              if (response.numberOfElements > 0) {
                    //console.log(response);
                    response.content.forEach((value) => {
                    // debugger;
                    this.addLogicToSearch(value);
                    // this.convertToDate(value);
                    })
                }
                //console.log(response);
                this.spinnerService.hideAll();
              return response;
              })
        );
      }

  searchToEmployee(entity?: AbsenceLeave, event?: LazyLoadEvent,
                    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<AbsenceLeave>> {

    const url = `${this.rutaServidor}${this.uri}search`;
    let httpParams = this.buildSentence(entity, event, extraSearchFields);
    httpParams = this.httpParams.set(QueryOperator.SearchName, 'searchToEmployee');
    this.spinnerService.showAll();
    return this.httpClient.get<ResponsePageable<AbsenceLeave>>(url, { params: httpParams })
        .pipe(
            tap(response => {
              //console.log('searchToEmployee Response');
              //console.log(response.content);
                if (response.numberOfElements > 0) {
                  //console.log(response);
                  response.content.forEach((value) => {
                      // debugger;
                      this.addLogicToSearch(value);
                      // this.convertToDate(value);
                  })
                }
                //console.log(response);
                this.spinnerService.hideAll();
                return response;
            })
        );
  }

  searchToEmployeeManager(entity?: AbsenceLeave, event?: LazyLoadEvent,
                            extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<AbsenceLeave>> { 
    const url = `${this.rutaServidor}${this.uri}search`;
    let httpParams = this.buildSentence(entity, event, extraSearchFields);
    httpParams = this.httpParams.set(QueryOperator.SearchName, 'searchToEmployeeManager');
    this.spinnerService.showAll();
    return this.httpClient.get<ResponsePageable<AbsenceLeave>>(url, { params: httpParams })
        .pipe(
            tap(response => {
              //console.log('searchToEmployeeManager');
                if (response.numberOfElements > 0) {
                  //console.log(response);
                  response.content.forEach((value) => {
                      // debugger;
                      this.addLogicToSearch(value);
                      // this.convertToDate(value);
                  })
                }
                //console.log(response);
                this.spinnerService.hideAll();
                return response;
            })
        );
  }

  createWithAttachment(absenceLeave: AbsenceLeave, files: File[]): Observable<any> {
    //console.log('createWithAttachment');
    const url = `${this.rutaServidor}${this.uri}attachment`;
    const uploadData = new FormData(); 
    //console.log(absenceLeave); 
    //console.log(files);
    uploadData.append('absenceLeave', JSON.stringify(absenceLeave))
    //console.log(uploadData);
    if (files) {
      files.forEach((file) => {
        uploadData.append('files', file, file.name);
      })
    }
    //console.log(uploadData);
    this.spinnerService.showAll();
    return this.httpClient.post<any>(url, uploadData)
      .pipe(
        tap(response => {
            if (response.numberOfElements > 0) {
              //console.log(response);
              response.content.forEach((value) => {
                  // this.convertToDate(value);
              })
            }
            this.spinnerService.hideAll();
            return response;
        })
      );
  } 

  // service utilizado por el trabajador para modificar datos en su papeleta observada
  updateAbsenceLeaveObserved(absenceLeave: AbsenceLeave, id :number, files: File[]): Observable<any> {
    //console.log('updateAbsenceLeaveObserved');
    const url = `${this.rutaServidor}${this.uri}updateAbsenceLeaveObserved` ;
    const uploadData = new FormData();
    absenceLeave.id =id
    //console.log(absenceLeave);
    //console.log(id);
    //console.log(files);
    uploadData.append('absenceLeave', JSON.stringify(absenceLeave)); 

    //console.log(uploadData);
    if (files) {
      files.forEach((file) => {
        uploadData.append('files', file, file.name);
      })
    }
    //console.log(uploadData);
    this.spinnerService.showAll();
    return this.httpClient.post<any>(url, uploadData)
      .pipe(
        tap(response => {
            if (response.numberOfElements > 0) {
              //console.log(response);
              response.content.forEach((value) => {
                  // this.convertToDate(value);
              })
            }
            this.spinnerService.hideAll();
            return response;
        })
      );
  }

  
    // service utilizado por el superusuario para cambiar algunos checks de ua papeleta aprobada
    updateAbsenceLeaveApproved(absenceLeave: AbsenceLeave, id :number, files: File[]): Observable<any> {
      //console.log('updateAbsenceLeaveApproved');
      const url = `${this.rutaServidor}${this.uri}updateAbsenceLeaveApproved` ;
      const uploadData = new FormData();
      absenceLeave.id =id
      //console.log(absenceLeave);
      //console.log(id);
      //console.log(files);
      uploadData.append('absenceLeave', JSON.stringify(absenceLeave)); 
  
      //console.log(uploadData);
      if (files) {
        files.forEach((file) => {
          uploadData.append('files', file, file.name);
        })
      }
      //console.log(uploadData);
      this.spinnerService.showAll();
      return this.httpClient.post<any>(url, uploadData)
        .pipe(
          tap(response => {
              if (response.numberOfElements > 0) {
                //console.log(response);
                response.content.forEach((value) => {
                    // this.convertToDate(value);
                })
              }
              this.spinnerService.hideAll();
              return response;
          })
        );
    }


  // service utilizado por el employeeManager para cambiar el estado de una papeleta por aprobar a una  observada o aproobada
  updateAbsenceLeaveToApprove(absenceLeave: AbsenceLeave, id :number, files: File[]): Observable<any> {
    //console.log('updateAbsenceLeaveToApprove');
    const url = `${this.rutaServidor}${this.uri}updateAbsenceLeaveToApprove` ;
    const uploadData = new FormData();
    absenceLeave.id =id
    //console.log(absenceLeave);
    //console.log(id);
    //console.log(files);
    uploadData.append('absenceLeave', JSON.stringify(absenceLeave)); 

    //console.log(uploadData);
    if (files) {
      files.forEach((file) => {
        uploadData.append('files', file, file.name);
      })
    }
    //console.log(uploadData);
    this.spinnerService.showAll();
    return this.httpClient.post<any>(url, uploadData)
      .pipe(
        tap(response => {
            if (response.numberOfElements > 0) {
              //console.log(response);
              response.content.forEach((value) => {
                  // this.convertToDate(value);
              })
            }
            this.spinnerService.hideAll();
            return response;
        })
      );
  }


  downloadAttendanceStubReport(absenceLeave: AbsenceLeave): Observable<Blob> {
    //console.log('downloadAttendanceStubReport');
    const url = `${this.rutaServidor}${this.uri}${absenceLeave.id}/report/attendance-stub/${absenceLeave.language}`;
    this.spinnerService.showAll();
    return this.httpClient.get(url, {responseType: 'blob' })
      .pipe(
        tap(response => {
          //console.log('dowloadAttachment');
          //console.log(response);
          this.spinnerService.hideAll();
        })
      );
  }

  validateAbsenceLeave(absenceLeaveList: AbsenceLeaveImport[]) {
    const url = `${this.rutaServidor}${this.uri}import/absenceLeave/`;
    this.spinnerService.showAll();
    this.httpParams = this.httpParams.set(QueryOperator.Action, 'validate');
    return this.httpClient.post<AbsenceLeaveImport[]>(url, absenceLeaveList, { params: this.httpParams })
      .pipe(
        tap(response => {
          this.spinnerService.hideAll();
        })
      );
  }

  createAbsenceLeave(absenceLeaveList: AbsenceLeaveImport[]) {
    const url = `${this.rutaServidor}${this.uri}import/absenceLeave/`;
    this.spinnerService.showAll();
    this.httpParams = this.httpParams.set(QueryOperator.Action, 'create');
    return this.httpClient.post<AbsenceLeaveImport[]>(url, absenceLeaveList, { params: this.httpParams })
      .pipe(
        tap(response => {
          this.spinnerService.hideAll();
        })
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/absence-leave.service.ts